<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div>
      <div class="page-amounts">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li class="page-item" :class="{ selected: amount === 3 }">
              <a @click="amount = 3" class="page-link paginate">3</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 10 }">
              <a @click="amount = 10" class="page-link paginate">10</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 50 }">
              <a @click="amount = 50" class="page-link paginate">50</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 100 }">
              <a @click="amount = 100" class="page-link paginate">100</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 150 }">
              <a @click="amount = 150" class="page-link paginate">150</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="paginator-info-top m-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
    </div>
    <div class="container-table">
      <table class="table table-striped- table-bordered table-hover table-checkable">
        <thead>
          <tr>
            <td
              nowrap
              class="text-center align-middle pointer"
              width="70"
              :class="{ 'table-sorted': sortType == 'id_griffin' }"
              @click="sortCall('id_griffin')"
            >
              ID Griffin
              <span
                class="fas fa-caret-down sorted"
                v-if="sortType == 'id_griffin' && !sortReverse"
              ></span>
              <span
                class="fas fa-caret-up sorted"
                v-if="sortType == 'id_griffin' && sortReverse"
              ></span>
              <span class="fal fa-sort sort" v-if="sortType != 'id_griffin'"></span>
            </td>
            <td
              nowrap
              class="text-center align-middle pointer"
              width="70"
              :class="{ 'table-sorted': sortType == 'id_mktzap' }"
              @click="sortCall('id_mktzap')"
            >
              ID Mktzap
              <span
                class="fas fa-caret-down sorted"
                v-if="sortType == 'id_mktzap' && !sortReverse"
              ></span>
              <span
                class="fas fa-caret-up sorted"
                v-if="sortType == 'id_mktzap' && sortReverse"
              ></span>
              <span class="fal fa-sort sort" v-if="sortType != 'id_mktzap'"></span>
            </td>
            <td nowrap class="text-center align-middle pointer" width="100">Nome</td>
            <td nowrap class="text-center align-middle pointer" width="100">CNPJ</td>
            <td nowrap class="text-center align-middle pointer" width="100">Ativa no Griffin</td>
            <td nowrap class="text-center align-middle pointer" width="100">Ativa no Mktzap</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type="text"
                class="form-control form-control-sm m-input"
                v-model="filters.idGriffin"
                v-b-tooltip.hover
                title="Filtrar por ID do Griffin"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm m-input"
                v-model="filters.idMktzap"
                v-b-tooltip.hover
                title="Filtrar por ID do Mktzap"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm m-input"
                v-model="filters.name"
                v-b-tooltip.hover
                title="Filtrar por nome da carteira"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm m-input"
                v-model="filters.cnpj"
                v-b-tooltip.hover
                title="Filtrar CNPJ"
              />
            </td>
            <td>
              <SelectYesNo
                :selected="filters.activeGriffin"
                @change="setFilter('activeGriffin', $event)"
                class="form-control-sm"
              />
            </td>
            <td>
              <SelectYesNo
                :selected="filters.activeMktzap"
                @change="setFilter('activeMktzap', $event)"
                class="form-control-sm"
              />
            </td>
          </tr>
          <tr v-for="(company, id) in data.data" :key="id">
            <td class="text-center align-middle">{{ company.id_griffin }}</td>
            <td class="text-center align-middle">{{ company.id_mktzap }}</td>
            <td class="text-left align-middle">{{ company.name }}</td>
            <td class="text-center align-middle">{{ company.cnpj | cnpj }}</td>
            <td class="text-center align-middle">
              {{ company.active_griffin == 1 ? 'Sim' : 'Não' }}
            </td>
            <td class="text-center align-middle">
              {{ company.active_mktzap == 1 ? 'Sim' : 'Não' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <div class="paginator-info-bottom mt-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
      <div class="paginator-list">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li class="page-item" :class="{ disabled: data.current_page === 1 }">
              <a class="page-link paginate" @click="page = 1">
                <i class="fal fa-angle-double-left"></i>
              </a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === 1 }">
              <a class="page-link paginate" @click="page = data.current_page - 1">
                <i class="fal fa-angle-left"></i>
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
              v-if="data.current_page > 2"
            >
              <a class="page-link paginate" @click="page = data.current_page - 2">{{
                data.current_page - 2
              }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
              v-if="data.current_page > 1"
            >
              <a class="page-link paginate" @click="page = data.current_page - 1">{{
                data.current_page - 1
              }}</a>
            </li>
            <li class="page-item selected">
              <a class="page-link paginate">{{ data.current_page }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === data.last_page }"
              v-if="data.current_page < data.last_page"
            >
              <a class="page-link paginate" @click="page = data.current_page + 1">{{
                data.current_page + 1
              }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page + 1 === data.last_page }"
              v-if="data.current_page + 1 < data.last_page"
            >
              <a class="page-link paginate" @click="page = data.current_page + 2">{{
                data.current_page + 2
              }}</a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === data.last_page }">
              <a class="page-link paginate" @click="page = data.current_page + 1">
                <i class="fal fa-angle-right"></i>
              </a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === data.last_page }">
              <a class="page-link paginate" @click="page = data.last_page">
                <i class="fal fa-angle-double-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectYesNo from '@/components/forms/SelectYesNo';
import { Money } from 'v-money';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportCustomerGriffinMktzap',
  props: ['start', 'finish'],
  components: {
    Money,
    SelectYesNo,
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      data: {},
      sortType: localStorage.companiesMktzapGriffinSortType
        ? localStorage.companiesMktzapGriffin
        : 'company_id',
      sortReverse: localStorage.companiesMktzapGriffinSortReverse
        ? localStorage.companiesMktzapGriffinReverse
        : false,
      amount: localStorage.companiesMktzapGriffinDataAmount
        ? localStorage.companiesMktzapGriffinDataAmount
        : 100,
      page: localStorage.companiesMktzapGriffinDataPage
        ? localStorage.companiesMktzapGriffinDataPage
        : 1,
      filters: {
        idGriffin: localStorage.companiesMktzapGriffinFilterIdGriffin
          ? localStorage.companiesMktzapGriffinFilterIdGriffin
          : '',
        idMktzap: localStorage.companiesMktzapGriffinFilterIdMktzap
          ? localStorage.companiesMktzapGriffinFilterIdMktzap
          : '',
        name: localStorage.companiesMktzapGriffinFilterName
          ? localStorage.companiesMktzapGriffinFilterName
          : '',
        cnpj: localStorage.companiesMktzapGriffinFilterCnpj
          ? localStorage.companiesMktzapGriffinFilterCnpj
          : '',
        activeGriffin: localStorage.companiesMktzapGriffinFilterActiveGriffin
          ? localStorage.companiesMktzapGriffinFilterActiveGriffin
          : '',
        activeMktzap: localStorage.companiesMktzapGriffinFilterActiveMktzap
          ? localStorage.companiesMktzapGriffinFilterActiveMktzap
          : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/report/companies/mktzap-comparation/download/${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_faturas`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);
          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('companiesMktzapGriffinFilterIdGriffin', this.filters.idGriffin);
      localStorage.setItem('companiesMktzapGriffinFilterIdMKtzap', this.filters.idMktzap);
      localStorage.setItem('companiesMktzapGriffinFilterName', this.filters.name);
      localStorage.setItem('companiesMktzapGriffinFilterCnpj', this.filters.cnpj);
      localStorage.setItem('companiesMktzapGriffinFilterActiveGriffin', this.filters.activeGriffin);
      localStorage.setItem('companiesMktzapGriffinFilterActiveMktzap', this.filters.activeMktzap);
      localStorage.setItem('companiesMktzapGriffinDataAmount', this.amount);
      localStorage.setItem('companiesMktzapGriffinDataPage', this.page);
      localStorage.setItem('companiesMktzapGriffinSortType', this.sortType);
      localStorage.setItem('companiesMktzapGriffinSortReverse', this.sortReverse);
    },
    convertFilters() {
      return `?page=${this.page ? this.page : 1}&idMktzap=${
        this.filters.idMktzap ? this.filters.idMktzap : ''
      }&idGriffin=${this.filters.idGriffin ? this.filters.idGriffin : ''}&name=${
        this.filters.name ? this.filters.name : ''
      }&cnpj=${this.filters.cnpj ? this.filters.cnpj : ''}&activeGriffin=${
        this.filters.activeGriffin ? this.filters.activeGriffin : ''
      }&activeMktzap=${this.filters.activeMktzap ? this.filters.activeMktzap : ''}&month=${
        this.filters.month ? this.filters.month : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }`;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      this.getFilteredData();
    },
    getFilteredData() {
      const url = `${baseApiUrl}/v1/report/companies/mktzap-comparation${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.clearAlert();
          this.$emit('updateLoading');
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
